export const DEFAULT_PREMIUM_CARD_THEME = "violet";
export const DEFAULT_PREMIUM_CARD_EFFECT_INTENSITY = "full";

export const PREMIUM_CARD_THEMES = [
  {
    id: "violet",
    label: "Violet",
    swatch: "#8c6bff",
    soft: "143, 213, 255",
    main: "93, 204, 255",
    mid: "151, 184, 255",
    accent: "160, 164, 255",
    deep: "179, 84, 255",
  },
  {
    id: "emerald",
    label: "Emerald",
    swatch: "#37d8a2",
    soft: "176, 247, 222",
    main: "88, 230, 176",
    mid: "54, 186, 145",
    accent: "28, 155, 128",
    deep: "17, 126, 112",
  },
  {
    id: "amber",
    label: "Amber",
    swatch: "#f4bc3a",
    soft: "255, 236, 174",
    main: "255, 205, 102",
    mid: "255, 168, 76",
    accent: "255, 131, 67",
    deep: "240, 92, 48",
  },
  {
    id: "orange",
    label: "Orange",
    swatch: "#f7944b",
    soft: "255, 222, 180",
    main: "255, 171, 104",
    mid: "255, 129, 79",
    accent: "255, 100, 58",
    deep: "221, 74, 34",
  },
  {
    id: "sapphire",
    label: "Sapphire",
    swatch: "#4fa0ff",
    soft: "171, 226, 255",
    main: "98, 190, 255",
    mid: "74, 142, 255",
    accent: "100, 113, 255",
    deep: "132, 109, 255",
  },
  {
    id: "rose",
    label: "Rose",
    swatch: "#ff6eb8",
    soft: "255, 210, 235",
    main: "255, 132, 196",
    mid: "238, 102, 185",
    accent: "213, 84, 171",
    deep: "171, 66, 145",
  },
];

export const PREMIUM_CARD_EFFECT_INTENSITIES = [
  { id: "off", label: "0%" },
  { id: "low", label: "35%" },
  { id: "medium", label: "70%" },
  { id: "full", label: "100%" },
];

const INTENSITY_VARS = {
  off: {
    shellOpacity: "0",
    shellBlurOpacity: "0",
    surfaceBorderOpacity: "0",
    surfaceMainGlowOpacity: "0",
    surfaceAccentGlowOpacity: "0",
    overlayMainOpacity: "0",
    overlayAccentOpacity: "0",
    overlayTopOpacity: "0",
    overlayBottomOpacity: "0",
    pillBorderOpacity: "0.55",
    pillInsetOpacity: "0.18",
    titleShadowOpacity: "0.16",
    primaryGlowOpacity: "0.24",
    avatarRingOutlineOpacity: "0.32",
    avatarGlowMainOpacity: "0.16",
    avatarGlowAccentOpacity: "0.12",
    actionLabelShadowOpacity: "0.24",
    identityShadowOpacity: "0.18",
  },
  low: {
    shellOpacity: "0.3",
    shellBlurOpacity: "0.2",
    surfaceBorderOpacity: "0.16",
    surfaceMainGlowOpacity: "0.055",
    surfaceAccentGlowOpacity: "0.038",
    overlayMainOpacity: "0.06",
    overlayAccentOpacity: "0.045",
    overlayTopOpacity: "0.04",
    overlayBottomOpacity: "0.025",
    pillBorderOpacity: "0.38",
    pillInsetOpacity: "0.12",
    titleShadowOpacity: "0.1",
    primaryGlowOpacity: "0.14",
    avatarRingOutlineOpacity: "0.18",
    avatarGlowMainOpacity: "0.1",
    avatarGlowAccentOpacity: "0.08",
    actionLabelShadowOpacity: "0.14",
    identityShadowOpacity: "0.1",
  },
  medium: {
    shellOpacity: "0.62",
    shellBlurOpacity: "0.46",
    surfaceBorderOpacity: "0.36",
    surfaceMainGlowOpacity: "0.14",
    surfaceAccentGlowOpacity: "0.1",
    overlayMainOpacity: "0.16",
    overlayAccentOpacity: "0.13",
    overlayTopOpacity: "0.11",
    overlayBottomOpacity: "0.07",
    pillBorderOpacity: "0.55",
    pillInsetOpacity: "0.2",
    titleShadowOpacity: "0.2",
    primaryGlowOpacity: "0.28",
    avatarRingOutlineOpacity: "0.38",
    avatarGlowMainOpacity: "0.2",
    avatarGlowAccentOpacity: "0.16",
    actionLabelShadowOpacity: "0.26",
    identityShadowOpacity: "0.22",
  },
  full: {
    shellOpacity: "0.92",
    shellBlurOpacity: "0.72",
    surfaceBorderOpacity: "0.62",
    surfaceMainGlowOpacity: "0.26",
    surfaceAccentGlowOpacity: "0.18",
    overlayMainOpacity: "0.28",
    overlayAccentOpacity: "0.24",
    overlayTopOpacity: "0.18",
    overlayBottomOpacity: "0.11",
    pillBorderOpacity: "0.78",
    pillInsetOpacity: "0.34",
    titleShadowOpacity: "0.38",
    primaryGlowOpacity: "0.48",
    avatarRingOutlineOpacity: "0.65",
    avatarGlowMainOpacity: "0.38",
    avatarGlowAccentOpacity: "0.3",
    actionLabelShadowOpacity: "0.42",
    identityShadowOpacity: "0.36",
  },
};

export const normalizePremiumCardTheme = (themeId) => {
  if (PREMIUM_CARD_THEMES.some((theme) => theme.id === themeId)) {
    return themeId;
  }
  return DEFAULT_PREMIUM_CARD_THEME;
};

export const normalizePremiumCardEffectIntensity = (intensityId) => {
  if (
    PREMIUM_CARD_EFFECT_INTENSITIES.some(
      (intensity) => intensity.id === intensityId
    )
  ) {
    return intensityId;
  }
  return DEFAULT_PREMIUM_CARD_EFFECT_INTENSITY;
};

export const getPremiumCardTheme = (themeId) =>
  PREMIUM_CARD_THEMES.find((theme) => theme.id === normalizePremiumCardTheme(themeId)) ||
  PREMIUM_CARD_THEMES[0];

export const getPremiumCardThemeCssVars = (themeId, intensityId) => {
  const theme = getPremiumCardTheme(themeId);
  const intensity = INTENSITY_VARS[normalizePremiumCardEffectIntensity(intensityId)];

  return {
    "--vg-premium-soft": theme.soft,
    "--vg-premium-main": theme.main,
    "--vg-premium-mid": theme.mid,
    "--vg-premium-accent": theme.accent,
    "--vg-premium-deep": theme.deep,
    "--vg-premium-shell-opacity": intensity.shellOpacity,
    "--vg-premium-shell-blur-opacity": intensity.shellBlurOpacity,
    "--vg-premium-surface-border-opacity": intensity.surfaceBorderOpacity,
    "--vg-premium-surface-main-glow-opacity": intensity.surfaceMainGlowOpacity,
    "--vg-premium-surface-accent-glow-opacity": intensity.surfaceAccentGlowOpacity,
    "--vg-premium-overlay-main-opacity": intensity.overlayMainOpacity,
    "--vg-premium-overlay-accent-opacity": intensity.overlayAccentOpacity,
    "--vg-premium-overlay-top-opacity": intensity.overlayTopOpacity,
    "--vg-premium-overlay-bottom-opacity": intensity.overlayBottomOpacity,
    "--vg-premium-pill-border-opacity": intensity.pillBorderOpacity,
    "--vg-premium-pill-inset-opacity": intensity.pillInsetOpacity,
    "--vg-premium-title-shadow-opacity": intensity.titleShadowOpacity,
    "--vg-premium-primary-glow-opacity": intensity.primaryGlowOpacity,
    "--vg-premium-avatar-ring-outline-opacity": intensity.avatarRingOutlineOpacity,
    "--vg-premium-avatar-glow-main-opacity": intensity.avatarGlowMainOpacity,
    "--vg-premium-avatar-glow-accent-opacity": intensity.avatarGlowAccentOpacity,
    "--vg-premium-action-label-shadow-opacity": intensity.actionLabelShadowOpacity,
    "--vg-premium-identity-shadow-opacity": intensity.identityShadowOpacity,
  };
};
